function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: 12px;\n  margin-right: 9px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1;\n  margin-right: ",
        ";\n  padding: 10px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled, { useTheme } from "styled-components";
import CheckmarkCircleIcon from "../Svg/Icons/CheckmarkCircle";
import ErrorIcon from "../Svg/Icons/Error";
import InfoIcon from "../Svg/Icons/Info";
import { Text } from "../Text";
import { IconButton } from "../Button";
import { AlertIcon, AlertIconReverse, CloseIcon } from "../Svg";
import Flex from "../Box/Flex";
import { variants } from "./types";
var getThemeColor = function(theme, variant) {
    switch(variant){
        case variants.DANGER:
            return "#FF5E5E";
        case variants.WARNING:
            return "#FCC824";
        case variants.SUCCESS:
            return "#3CE0D6";
        case variants.INFO:
            return "#194BFB";
        default:
            return theme.colors.primary;
    }
};
var getIcon = function() {
    var variant = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : variants.INFO;
    switch(variant){
        case variants.DANGER:
            return ErrorIcon;
        case variants.WARNING:
            return AlertIcon;
        case variants.SUCCESS:
            return CheckmarkCircleIcon;
        case variants.INFO:
            return AlertIconReverse;
        default:
            return InfoIcon;
    }
};
var IconLabel = styled.div.withConfig({
    componentId: "sc-cfccade9-0"
})(_templateObject());
var withHandlerSpacing = 32 + 12; // button size + inner spacing + handler position
var Details = styled.div.withConfig({
    componentId: "sc-cfccade9-1"
})(_templateObject1(), function(param) {
    var hasHandler = param.hasHandler;
    return hasHandler ? "".concat(withHandlerSpacing, "px") : "12px";
});
var Alert = function(param) {
    var title = param.title, children = param.children, variant = param.variant, onClick = param.onClick;
    var Icon = getIcon(variant);
    var theme = useTheme();
    return /*#__PURE__*/ _jsxs(Flex, {
        style: {
            backgroundColor: getThemeColor(theme, variant),
            borderRadius: 16
        },
        children: [
            /*#__PURE__*/ _jsx("div", {
                style: {
                    alignSelf: "center"
                },
                children: /*#__PURE__*/ _jsx(IconLabel, {
                    variant: variant,
                    hasDescription: !!children,
                    children: /*#__PURE__*/ _jsx(Icon, {
                        stroke: "white",
                        style: {
                            alignSelf: "center"
                        }
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                style: {
                    background: theme.colors.toastBackground,
                    flexGrow: 1,
                    margin: 3,
                    borderRadius: 16,
                    padding: 12
                },
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        style: {
                            flexGrow: 1
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                color: theme.colors.hardTextColor,
                                fontSize: "12px",
                                children: title
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                color: getThemeColor(theme, variant),
                                fontSize: "12px",
                                as: "p",
                                children: children
                            })
                        ]
                    }),
                    onClick && /*#__PURE__*/ _jsx("div", {
                        style: {
                            alignSelf: "center"
                        },
                        children: /*#__PURE__*/ _jsx(IconButton, {
                            style: {
                                width: 14,
                                height: 14
                            },
                            variant: "text",
                            onClick: onClick,
                            children: /*#__PURE__*/ _jsx(CloseIcon, {
                                width: "12px",
                                height: "12px",
                                color: "currentColor"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
export default Alert;
